import { Collapse } from 'antd';
import styled, { css } from 'styled-components';
import { media } from 'components/styles';

// Import icons
import { ReactComponent as IconArrowDown } from 'assets/icons/ic_arrow_down.svg';

const { Panel } = Collapse;

export const Section = styled.section`
	width: 100%;
	margin: 0 auto;
	padding: 6rem 2rem 10rem;

	${media.min.min(css`
		padding: 11.7rem 4rem 15rem;
	`)}
	${media.min.medium(css`
		padding: 11.7rem 6rem 15rem;
	`)}
	${media.min.max(css`
		margin: 0 auto;
		padding: 11.7rem 16rem 15rem;
		max-width: ${media.sizes.max}px;
	`)}
`;

export const Title = styled.h1`
	color: ${({ theme: { introduce } }) => introduce.color};
	font-size: ${({ theme: { introduce } }) => introduce.faq.font.title.base}rem;
	font-weight: ${({ theme }) => theme.font.normal};
	text-align: center;
	margin-bottom: 4.5rem;

	${media.min.min(css`
		font-size: ${({ theme: { introduce } }) => introduce.faq.font.title.min}rem;
		margin-bottom: 9.1rem;
	`)}
`;

export const Question = styled(Panel)`
	background-color: ${({ theme, primary }) =>
		primary ? theme.faq.primaryBackgroundColor : theme.faq.backgroundColor};
	font-size: ${({ theme }) => theme.faq.header.fontSizeBase}rem;
	white-space: pre-line;
	border-bottom: 1px solid ${({ theme }) => theme.faq.borderColor} !important;

	${media.min.xmin(css`
		font-size: ${({ theme }) => theme.faq.header.fontSizeMin}rem;
	`)};
	${media.min.large(css`
		font-size: ${({ theme }) => theme.faq.header.fontSize}rem;
	`)};
	& .ant-collapse-header {
		color: white !important;
		line-height: 2.4rem !important;
		padding: 2rem 0 !important;
		padding-right: 6rem !important;
		box-sizing: border-box;
		border: none;
		${media.min.min(css`
			line-height: 3.6rem !important;
			padding: 3rem 0 !important;
		`)};
	}
	& .ant-collapse-content-box {
		padding: 0 !important;
		padding-bottom: 3rem !important;
		font-weight: lighter;
		margin: 0 !important;
	}
`;

export const Anwser = styled.div`
	text-align: justify;
	font-size: ${({ theme }) => theme.faq.body.fontSizeBase}rem;
	color: ${({ theme }) => theme.white};
	font-weight: ${({ theme }) => theme.faq.body.fontWeight} !important;
	line-height: 2rem !important;
	padding: 0;

	ul li {
		list-style: disc outside none;
		display: list-item;
		margin-left: 1.5em;
	}
	ol {
		margin: 2rem 0;
		li {
			list-style: decimal outside none;
			display: list-item;
			margin-left: 0em;
			&:marker {
				margin-right: 1rem !important;
			}
		}
	}
	a {
		color: ${({ theme }) => theme.blueAzure};
		&:hover {
			text-decoration: underline;
		}
	}

	${media.min.xmin(css`
		font-size: ${({ theme }) => theme.faq.body.fontSize}rem;
		line-height: 2.4rem !important;
		text-align: left;
		padding-right: 5rem !important;
	`)};
`;

export const Arrow = styled(IconArrowDown)`
	width: 1.5rem;
	height: 0.8rem;

	g > g {
		fill: ${({ theme }) => theme.faq.arrowColor};
	}

	${({ active }) =>
		active === 'true' &&
		css`
			transform: rotate(180deg);
		`};
`;
